import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * CRM Module Service Stores
 */
export const crmStores: ServiceStoreConfig[] = [
  // TODO: Uncomment when accounts table is created on backend
  // {
  //   name: "accounts",
  //   options: {
  //     enableStorage: true,
  //     enableErrorNotifications: true,
  //     idField: "accountId",
  //     serviceView: {
  //       enableServiceView: false,
  //       summaryCards: (rootStore) => {
  //         return [
  //           {
  //             title: "Total Accounts",
  //             value: () => {
  //               const accountsStore = rootStore.accountsStore as {
  //                 entities?: unknown[];
  //               };
  //               const entities = accountsStore?.entities || [];
  //               return entities.length.toString();
  //             },
  //             valueColor: "primary.main",
  //             variant: "with-icon" as const,
  //           },
  //           {
  //             title: "With Website",
  //             value: () => {
  //               const accountsStore = rootStore.accountsStore as {
  //                 entities?: unknown[];
  //               };
  //               const entities = accountsStore?.entities || [];
  //               const accountsWithWebsite = entities.filter(
  //                 (account: Record<string, unknown>) => account.website
  //               ).length;
  //               return accountsWithWebsite.toString();
  //             },
  //             valueColor: "success.main",
  //           },
  //           {
  //             title: "With Billing",
  //             value: () => {
  //               const accountsStore = rootStore.accountsStore as {
  //                 entities?: unknown[];
  //               };
  //               const entities = accountsStore?.entities || [];
  //               const accountsWithBilling = entities.filter(
  //                 (account: Record<string, unknown>) => account.billingAddress
  //               ).length;
  //               return accountsWithBilling.toString();
  //             },
  //             valueColor: "info.main",
  //           },
  //           {
  //             title: "Recent (30 days)",
  //             value: () => {
  //               const accountsStore = rootStore.accountsStore as {
  //                 entities?: unknown[];
  //               };
  //               const entities = accountsStore?.entities || [];
  //               const recentAccounts = entities.filter(
  //                 (account: Record<string, unknown>) => {
  //                   const createdDate = new Date(account.createdAt as string);
  //                   const thirtyDaysAgo = new Date();
  //                   thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  //                   return createdDate > thirtyDaysAgo;
  //                 }
  //               ).length;
  //               return recentAccounts.toString();
  //             },
  //             valueColor: "warning.main",
  //           },
  //         ];
  //       },
  //       permissions: {
  //         requiresAuth: true,
  //         requiresAdmin: false,
  //       },
  //       actions: {
  //         onRowClick: (row) => {
  //           // Navigate to account detail
  //           console.log("View account:", row.accountId);
  //         },
  //         onRowDoubleClick: (row, rootStore) => {
  //           rootStore.routerStore?.openDialog({
  //             dialogName: "accountDetail",
  //             dialogContext: `${row.accountId}`,
  //           });
  //         },
  //       },
  //     },
  //   },
  // },
  // TODO: Uncomment when bids table is created on backend
  // {
  //   name: "bids",
  //   options: {
  //     enableStorage: true,
  //     enableErrorNotifications: true,
  //     // idField: "bidId",
  //     serviceView: {
  //       enableServiceView: false,
  //       summaryCards: (rootStore) => {
  //         const store = rootStore.bidsStore as { entities?: unknown[] };
  //         const entities = store?.entities || [];
  //         const totalBids = entities.length;
  //         const pendingBids = entities.filter(
  //           (bid: Record<string, unknown>) =>
  //             bid.status === "pending" || bid.status === "submitted"
  //         ).length;
  //         const wonBids = entities.filter(
  //           (bid: Record<string, unknown>) =>
  //             bid.status === "won" || bid.status === "accepted"
  //         ).length;
  //         const totalBidValue = entities.reduce(
  //           (sum: number, bid: Record<string, unknown>) => {
  //             return (
  //               sum + ((bid.amount as number) || (bid.value as number) || 0)
  //             );
  //           },
  //           0
  //         );
  //
  //         return [
  //           {
  //             title: "Total Bids",
  //             value: () => totalBids.toString(),
  //             valueColor: "primary.main",
  //           },
  //           {
  //             title: "Pending",
  //             value: () => pendingBids.toString(),
  //             valueColor: "warning.main",
  //           },
  //           {
  //             title: "Won",
  //             value: () => wonBids.toString(),
  //             valueColor: "success.main",
  //           },
  //           {
  //             title: "Total Value",
  //             value: () => `$${((totalBidValue as number) / 1000).toFixed(0)}K`,
  //             valueColor: "info.main",
  //           },
  //         ];
  //       },
  //       permissions: {
  //         requiresAuth: true,
  //         requiresAdmin: false,
  //       },
  //     },
  //   },
  // },
  {
    name: "purchase-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          return [
            {
              title: "Total Orders",
              value: () => {
                const purchaseOrdersStore = rootStore.purchaseOrdersStore as {
                  entities?: unknown[];
                };
                const entities = purchaseOrdersStore?.entities || [];
                return entities.length.toString();
              },
              valueColor: "primary.main",
            },
            {
              title: "Pending",
              value: () => {
                const purchaseOrdersStore = rootStore.purchaseOrdersStore as {
                  entities?: unknown[];
                };
                const entities = purchaseOrdersStore?.entities || [];
                const pendingOrders = entities.filter(
                  (po: Record<string, unknown>) =>
                    po.status === "pending" || po.status === "submitted"
                ).length;
                return pendingOrders.toString();
              },
              valueColor: "warning.main",
            },
            {
              title: "Completed",
              value: () => {
                const purchaseOrdersStore = rootStore.purchaseOrdersStore as {
                  entities?: unknown[];
                };
                const entities = purchaseOrdersStore?.entities || [];
                const completedOrders = entities.filter(
                  (po: Record<string, unknown>) =>
                    po.status === "completed" || po.status === "received"
                ).length;
                return completedOrders.toString();
              },
              valueColor: "success.main",
            },
            {
              title: "Total Value",
              value: () => {
                const purchaseOrdersStore = rootStore.purchaseOrdersStore as {
                  entities?: unknown[];
                };
                const entities = purchaseOrdersStore?.entities || [];
                const totalValue = entities.reduce(
                  (sum: number, po: Record<string, unknown>) => {
                    return sum + ((po.totalAmount as number) || 0);
                  },
                  0
                );
                return `$${(totalValue as number).toFixed(2)}`;
              },
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["createdAt"],
          sortDirection: { createdAt: "DESC" },
        },
        actions: {
          onRowClick: (row) => {
            console.log("View PO:", row.purchaseOrderId);
          },
        },
      },
    },
  },
  {
    name: "purchase-order-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "purchase-order-receipts",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "quotes",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "quote-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "sales-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "sales-order-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
  {
    name: "contacts",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      // idField: "contactId",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.contactsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalContacts = entities.length;
          const activeContacts = entities.filter(
            (contact: Record<string, unknown>) =>
              contact.status === "active" || !contact.inactive
          ).length;
          const vipContacts = entities.filter(
            (contact: Record<string, unknown>) =>
              contact.isVip || contact.priority === "high"
          ).length;
          const recentContacts = entities.filter(
            (contact: Record<string, unknown>) => {
              const createdDate = new Date(contact.createdAt as string);
              const weekAgo = new Date();
              weekAgo.setDate(weekAgo.getDate() - 7);
              return createdDate > weekAgo;
            }
          ).length;

          return [
            {
              title: "Total Contacts",
              value: () => totalContacts.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => activeContacts.toString(),
              valueColor: "success.main",
            },
            {
              title: "VIP",
              value: () => vipContacts.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Recent (7 days)",
              value: () => recentContacts.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "opportunities",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      // idField: "OpportunityId",
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.opportunitiesStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalOpportunities = entities.length;
          const openOpportunities = entities.filter(
            (opp: Record<string, unknown>) =>
              opp.status === "open" || opp.status === "active"
          ).length;
          const wonOpportunities = entities.filter(
            (opp: Record<string, unknown>) =>
              opp.status === "won" || opp.status === "closed-won"
          ).length;
          const totalValue = entities.reduce(
            (sum: number, opp: Record<string, unknown>) => {
              return (
                sum + ((opp.value as number) || (opp.amount as number) || 0)
              );
            },
            0
          );

          return [
            {
              title: "Total Opportunities",
              value: () => totalOpportunities.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Open",
              value: () => openOpportunities.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Won",
              value: () => wonOpportunities.toString(),
              valueColor: "success.main",
            },
            {
              title: "Pipeline Value",
              value: () => `$${((totalValue as number) / 1000000).toFixed(1)}M`,
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "activities",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "document-management",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "production-orders",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: false,
        summaryCards: (rootStore) => {
          const store = rootStore.productionOrdersStore as {
            entities?: unknown[];
          };
          const entities = store?.entities || [];
          const totalOrders = entities.length;
          const inProgressOrders = entities.filter(
            (order: Record<string, unknown>) =>
              order.status === "in_progress" || order.status === "processing"
          ).length;
          const completedOrders = entities.filter(
            (order: Record<string, unknown>) =>
              order.status === "completed" || order.status === "delivered"
          ).length;
          const delayedOrders = entities.filter(
            (order: Record<string, unknown>) => {
              const dueDate = new Date(order.dueDate as string);
              return dueDate < new Date() && order.status !== "completed";
            }
          ).length;

          return [
            {
              title: "Total Orders",
              value: () => totalOrders.toString(),
              valueColor: "primary.main",
            },
            {
              title: "In Progress",
              value: () => inProgressOrders.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Completed",
              value: () => completedOrders.toString(),
              valueColor: "success.main",
            },
            {
              title: "Delayed",
              value: () => delayedOrders.toString(),
              valueColor: "error.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
        defaultSort: {
          sortBy: ["dueDate"],
          sortDirection: { dueDate: "ASC" },
        },
      },
    },
  },
  // CRM AI services
  {
    name: "bid-analytics",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "opportunity-scorer",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "chatbot",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
];